import axios from '../../../commons/gdprcontrol-axios'

const state = {
  legalBaseAliases: []
}

const getters = {
  getLegalBaseAliases: state => state.legalBaseAliases
}

const actions = {
  fetchLegalBaseAliases: async ({ commit }) => {
    return axios.get('/api/legal-base-aliases/')
      .then(response => {
        commit('storeLegalBaseAliases', response.data)
      })
      .catch(error => {
        alert('Hiba a jogalapok letöltése közben')
        throw error
      })
  }
}

const mutations = {
  storeLegalBaseAliases (state, legalBaseAliases) {
    state.legalBaseAliases = legalBaseAliases
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/legalBaseAlias/list.js